import React from 'react';

import { config } from './app.config';

interface TeamsGuardProps {
  children: React.ReactNode;
}

export const TeamsGuard = ({ children }: TeamsGuardProps) =>
  config.app.isTeamsApp ? (
    <span style={{ pointerEvents: 'none' }}>{children}</span>
  ) : (
    <>{children}</>
  );
